import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import FeatureRenameMenuItem from "@/v2-backoffice-client/feature/rename/FeatureRenameMenuItem"
import NavLayerEnableMenuItem from "@/v2-backoffice-client/navlayer/enable/NavLayerEnableMenuItem"
import type { NavLayerFragment } from "@/v2-backoffice-client/navlayer/__types__/navlayer.fragment"

export type NavLayerActionMenuProps = {
  navLayer: NavLayerFragment
  /**
   * Requests the rename dialog. The dialog is owned by the TABLE, not this
   * menu: the row toolbar only exists while its row is hovered or holds an
   * open menu, so anything mounted here dies the moment the menu closes.
   */
  onRename(): void
}

function NavLayerActionMenu(props: NavLayerActionMenuProps) {
  const { navLayer, onRename } = props

  return (
    <ActionMenu>
      <ActionMenu.Trigger />

      <ActionMenu.Content>
        <NavLayerEnableMenuItem navLayer={navLayer} />
        <FeatureRenameMenuItem
          dataFeatureCode="UI_BackofficeNavLayers_Rename_MenuItem"
          onSelect={onRename}
        />
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default NavLayerActionMenu
